// Library
import React from 'react';

// Supermove
import {Icon, Space} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useResponsive} from '@supermove/hooks';
import {Communication, CommunicationModel} from '@supermove/models';

// Shared
import TertiaryButton from '@shared/design/components/Button/TertiaryButton';
import Text from '@shared/design/components/Text';

const CommunicationStatusAction = ({
  communication,
  handleAction,
  handleCallAction,
  handleSmsAction,
  handleEmailAction,
}: {
  communication: CommunicationModel;
  handleAction?: () => void;
  handleCallAction?: () => void;
  handleSmsAction?: () => void;
  handleEmailAction?: () => void;
}) => {
  const responsive = useResponsive();
  const {icon, color, text} = Communication.getStatusInfo(communication);
  const customAction = communication.email
    ? handleEmailAction
    : communication.textMessage
      ? handleSmsAction
      : handleCallAction;

  return (
    <TertiaryButton onPress={customAction || handleAction}>
      <Icon source={icon} color={color} size={responsive.desktop ? 14 : 16} />
      <Space width={4} />
      <Text.Link>{text}</Text.Link>
    </TertiaryButton>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
CommunicationStatusAction.fragment = gql`
  ${Communication.getStatusInfo.fragment}
  fragment CommunicationStatusAction on Communication {
    id
    email {
      id
    }
    textMessage {
      id
    }
    call {
      id
    }
    ...Communication_getStatusInfo
  }
`;

export default CommunicationStatusAction;
